module.exports = __webpack_public_path__ + "img/5.7e6950c6.jpg";